import { FC } from "react"
import images from "../../assets/loaders/imageLoader"
import useScroll from "../../hooks/useScroll"
import { Paths } from "../../routes/paths"

const Header: FC = () => {
  const isScrolled = useScroll({ threshold: 100 })

  return (
    <header className="fixed w-full z-50">
      <nav className={`bg-white shadow-lg ${isScrolled ? "opacity-100" : "opacity-0"} transition-all duration-500 ease-in-out`}>
        <div className={`container mx-auto px-4 ${isScrolled ? "block" : "hidden"}`}>
          <div className="flex justify-between items-center h-16">
            <a href={Paths.home} className="flex-shrink-0">
              <img
                src={images.logo}
                alt="Tierras de Paraná"
                className="w-24 h-auto"
              />
            </a>
            <div className="hidden md:flex space-x-8">
              <a href={Paths.home + "#main"} className="text-gray-600 hover:text-gray-900">Inicio</a>
              <a href={Paths.home + "#projects"} className="text-gray-600 hover:text-gray-900">Proyectos</a>
              <a href={Paths.home + "#about-us"} className="text-gray-600 hover:text-gray-900">Nosotros</a>
              <a href={Paths.home + "#contact-us"} className="text-gray-600 hover:text-gray-900">Contacto</a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Header
